var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14.7656C12.4173 14.7656 15.1875 11.9954 15.1875 8.57812C15.1875 5.16086 12.4173 2.39062 9 2.39062C5.58274 2.39062 2.8125 5.16086 2.8125 8.57812C2.8125 11.9954 5.58274 14.7656 9 14.7656ZM9 15.8906C13.0386 15.8906 16.3125 12.6167 16.3125 8.57812C16.3125 4.53954 13.0386 1.26562 9 1.26562C4.96142 1.26562 1.6875 4.53954 1.6875 8.57812C1.6875 12.6167 4.96142 15.8906 9 15.8906Z",
    fill: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    d: "M11.1788 10.5V10.575H11.2537H12H12.075V10.5V6V5.925H12H11.0325H10.9888L10.9673 5.96299L9.22352 9.03659L9.22349 9.03657L9.22252 9.0384C9.17781 9.12252 9.10621 9.26868 9.00805 9.47601C8.95828 9.35785 8.88717 9.2153 8.79571 9.04906L8.79556 9.0488L7.08181 5.96358L7.06038 5.925H7.01625H6H5.925V6V10.5V10.575H6H6.71625H6.79125V10.5V7.54551C6.79125 7.38335 6.7892 7.23636 6.78505 7.10465C6.79313 7.12161 6.801 7.1367 6.80866 7.14991C6.80874 7.15005 6.80882 7.15019 6.8089 7.15032L8.72094 10.5369L8.74247 10.575H8.78625H9.2025H9.24641L9.2679 10.5367L11.1838 7.12382C11.1869 7.11859 11.1899 7.11316 11.193 7.10754C11.1835 7.25701 11.1788 7.3943 11.1788 7.51937V10.5Z",
    fill: "#F9FAFA",
    stroke: "#F9FAFA",
    strokeWidth: 0.15
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmWhite);
export default __webpack_public_path__ + "static/media/confirm-white.584dd452cc11cc97f0191b52d7984fec.svg";
export { ForwardRef as ReactComponent };